'use strict';

var React = require('react');

/* Router */

var _require = require('react-router');

var RouteHandler = _require.RouteHandler;
var Navigation = _require.Navigation;

/* Stores */
var LanguageStore = require('stores/language');

var App = React.createClass({
  displayName: 'App',

  mixins: [Navigation],

  render: function render() {
    var component = this;
    var props = component.props;

    /* Translations */
    var translate = LanguageStore.translate;
    var titleTranslation = translate(props.name + '_page_title');

    return React.createElement(
      'div',
      { className: 'app-component' },
      React.createElement(
        'div',
        { className: 'menu' },
        React.createElement(
          'div',
          { className: 'home', onClick: component._onHomeClick },
          'ContentBase'
        ),
        React.createElement(
          'div',
          { className: 'title' },
          titleTranslation
        )
      ),
      React.createElement(RouteHandler, props)
    );
  },

  _onHomeClick: function _onHomeClick() {
    this.transitionTo('/');
  },

  _onLogoutClick: function _onLogoutClick() {
    window.location = '/logout';
  }
});

module.exports = App;


/** WEBPACK FOOTER **
 ** ../~/babel-loader!./js/components/app.js
 **/